import axios from 'axios'
import { BoltApiResponseBody } from 'types/bolt-api/request'
import { log } from 'utils/logging'
import { Criticality, Flow } from 'types/logging'
import { GetPlentyPaymentStatusResponse } from 'store/api/types'

/**
 * Get the payment status of a specific Plenty opportunity.
 * @param {string} plentyOpportunityId
 * @returns {Promise<unknown | undefined>}
 */
const getPlentyPaymentStatus = async (plentyOpportunityId: string): Promise<GetPlentyPaymentStatusResponse | undefined> => {
  try {
    const response = await axios.get<BoltApiResponseBody<GetPlentyPaymentStatusResponse>>(
      `${process.env.API_URL}/plenty/prospects/${plentyOpportunityId}/payment-status`,
      {
        headers: {
          Authorization: `Basic ${process.env.API_TOKEN}`
        }
      }
    )

    const {
      data: { success, data }
    } = response

    return success ? data : undefined
  } catch (error) {
    log({
      error,
      identifier: `[${Flow.REGISTRATION}:plenty:prospect:${plentyOpportunityId}:payment-status}]`,
      criticality: Criticality.HIGH
    })
    return undefined
  }
}

export default getPlentyPaymentStatus
